/**
 * 限时首充
 */

import { request } from '@/utils/request';

/** 限时首充查询接口 */
export const getFirstRecharge = () =>
  request({
    url: '/gamer/firstpay_query',
    method: 'GET'
  });

/** 限时首充七日领取 */
export const receiveSevenDay = () =>
  request({
    url: '/gamer/firstpay_sevenday_receive',
    method: 'POST'
  });

/** 限时首充2%领取*/
export const receiveFlowing = () =>
  request({
    url: '/gamer/firstpay_flow_receive',
    method: 'POST'
  });

/** 限时首充60倍领取*/
export const receiveMultiple = () =>
  request({
    url: '/gamer/firstpay_multie_receive',
    method: 'POST'
  });
